export const getBaseUrl = () => {
  return window.location.origin;
};
